import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-252b19ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onKeydown", "onKeyup", "title"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mxa-header-icon-svg",
  viewBox: "0 0 20 20",
  width: "50",
  height: "50"
}, [
  /*#__PURE__*/_createElementVNode("polygon", {
    stroke: "white",
    "stroke-width": "1",
    points: "13.1 13.4 12.5 12.8 15.28 10 8 10 8 9 15.28 9 12.5 6.2 13.1 5.62 17 9.5"
  }),
  /*#__PURE__*/_createElementVNode("polygon", {
    stroke: "white",
    "stroke-width": "1",
    points: "13 2 3 2 3 17 13 17 13 16 4 16 4 3 13 3"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import { logout } from '@/model/components/users/userLogout'
import * as log from '@/model/util/log/Logger'


import { defineComponent, ref } from 'vue'

const __default__ = defineComponent({
  inheritAttrs: false,
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TheHeaderLogout',
  setup(__props) {

log.trace(`TheHeaderLogout setup start.`)

// 状態
const store = useStore()
const router = useRouter()

// enterボタン開始有無
const isEnterStart = ref(false)

// ログアウトボタン押下処理
const onclick = () => {
  log.trace(`TheHeaderLogout onClick start.`)
  // enterのkeydownの状態は何もしない。keyupされるまで待つ
  if (isEnterStart.value) {
    log.debug(`TheHeaderLogout keydown exe.`)
    return
  }
  // ログアウト処理を実施してTOP画面に遷移する(正常・異常に関わらず)
  log.debug(`TheHeaderLogout onClick logout.`)
  logout(store, router)
  log.trace(`TheHeaderLogout onClick end.`)
}

/**
 * enter押下イベント
 */
const onKeydown = () => {
  log.trace(`TheHeaderLogout onKeydown.`)
  isEnterStart.value = true
}

/**
 * enter終了イベント
 */
const onKeyup = () => {
  log.trace(`TheHeaderLogout onKeydown.`)
  isEnterStart.value = false
  onclick()
}

log.trace(`TheHeaderLogout setup end.`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "btn mxa-header-icon mxa-header-button",
    onClick: onclick,
    onKeydown: _withKeys(onKeydown, ["enter"]),
    onKeyup: _withKeys(onKeyup, ["enter"]),
    title: _ctx.$t('header.logout.title'),
    "data-test": "header_title"
  }, _hoisted_3, 40, _hoisted_1))
}
}

})